import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { AccountSelectDto } from '../AccountSelect/models';
import { useGetAdminQuery } from '../People/TabsCard/AdminsTab/RemoveAdminModal/apiSlice';
import { userSelector } from '../../shared/store/shared/userSlice';
import { JwtDecodedUser } from '../../shared/models/UserModels';

export const ROLES = {
  'B2B:ADM': 'Administrator',
  'B2B:RPT': 'Reporter',
};

export default function AccountSwitcherSelectedMenuItem({
  account,
}: {
  account: AccountSelectDto;
}) {
  const { value: user } = useSelector(userSelector);
  const accessToken = user ? user.access_token : '';
  const authUser: JwtDecodedUser = jwtDecode(accessToken);

  const { data, isSuccess } = useGetAdminQuery({
    accountId: account.accountId,
    adminId: parseInt(authUser.id, 10),
  });

  return (
    <div
      key={account.accountId}
      className="account-switcher-menu-item p-3 is-selected d-flex align-items-center"
    >
      <input tabIndex={-1} type="radio" checked readOnly className="me-2" />
      <div>
        <span className="small fw-bold text-primary">
          {account.accountName}
        </span>
        <div className="smaller text-muted">
          {(isSuccess && ROLES[data?.accountRole?.roleId]) ?? 'Custom'}
        </div>
      </div>
    </div>
  );
}
